import { Component } from '@angular/core';
import { ContractService } from '../../../../../../shared/store/contract/contract.service';
import { Observable } from 'rxjs';
import { ContractModel } from '../../../../../../shared/store/contract/types';

@Component({
  selector: 'app-contract-details-insurance-claims',
  standalone: false,
  templateUrl: './contract-details-insurance-claims.component.html',
  styleUrl: './contract-details-insurance-claims.component.scss',
})
export class ContractDetailsInsuranceClaimsComponent {
  contract$: Observable<ContractModel>;
  constructor(private readonly contractService: ContractService) {
    this.contract$ = this.contractService.getByUniqueId.value$;
  }
}
